<div #textContainer class="text-marquee" [ngClass]="{ 'marquee-attention-color': this.config.highlight}" [ngStyle]="cssStyle">
  <div *ngIf="isOverflowing; else normalText" class="marquee {{cssChangeColor}}" 
    [ngStyle]="{ 'min-width': 'max-content'}">
    <span>{{ message || ''}}</span>
  </div>
  <ng-template #normalText>
    {{ message || '' }}
  </ng-template>
</div>
